// extracted by mini-css-extract-plugin
module.exports = {"box":"summer-styles_box__6I5iU"};